import { Navigate, useParams, useSearchParams } from 'react-router';
import { DrawdownPreviewView } from '@/components/drawdowns/drawdown-preview/DrawdownPreviewView';
import { useUpdateDrawdownStatus } from '@/hooks/react-query/useDrawdowns';

export default function DrawdownPreviewPage() {
  const [searchParams] = useSearchParams();
  const { fundId, drawdownId } = useParams<{
    fundId: string;
    drawdownId: string;
  }>();
  const updateStatusMutation = useUpdateDrawdownStatus();

  if (!fundId || !drawdownId) {
    return <Navigate to="/app/funds" replace />;
  }

  const handleStatusUpdate = async (
    targetDrawdownId: string,
    status: string
  ) => {
    await updateStatusMutation.mutateAsync({
      drawdownId: targetDrawdownId,
      status: { status },
      fundId,
    });
  };

  return (
    <DrawdownPreviewView
      fundId={fundId}
      drawdownId={drawdownId}
      initialBatchId={searchParams.get('batchId') || undefined}
      onStatusUpdate={handleStatusUpdate}
      isUpdatingStatus={updateStatusMutation.isPending}
    />
  );
}
